import React from 'react';
import StaffAugIntro from '../components/StaffAugIntro/StaffAugIntro';
import StaffAugWhyChoose from '../components/StaffAugWhyChoose/StaffAugWhyChoose';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const StaffAugmentationPage = () => {
  return (
    <>
      <StaffAugIntro />
      <StaffAugWhyChoose />
      <CtaSection />
    </>
  );
};

export default StaffAugmentationPage;
